<template>
  <div>
    <b-row>
      <b-container>
        <h1 class="text-center py-2">
          {{labels.title}}
        </h1>
      </b-container>
    </b-row>
    <b-row>
      <b-container>
        <h4 class="text-center border-bottom">
          {{labels.subtitle}}
        </h4>
        <b-col md="8" class="mx-auto">
          <ul>
            <li v-for="(item, idx) in labels.instructive" :key="idx">{{ item }}</li>
          </ul>
        </b-col>
      </b-container>
    </b-row>
    <b-row v-if="!isLoading">
      <b-container>
        <b-col md="10" class="mx-auto"> 
          <b-button @click="goToCreateMaterial()" id="create-btn">{{
              labels.create
            }}</b-button>
        </b-col>
      </b-container>
      <b-container v-if="!isEmpty" class="pb-5">
        <h4 class="text-center">
          {{labels.info}}
        </h4>
        <b-col md="12" class="mx-auto">
        <md-table
          v-model="searched"
          md-sort="denominacion"
          md-sort-order="desc"
          md-card
          md-fixed-header
        >
          <!-- <md-table-toolbar>
            <md-field md-clearable class="md-toolbar-section-start">
              <md-input
                :placeholder="labels.search"
                v-model="search"
                @input="searchOnTable"
              />
            </md-field>
          </md-table-toolbar> -->
          <md-table-row slot="md-table-row" slot-scope="{ item }" @click="showInfo(item.id)">
            <md-table-cell :md-label="labels.denominacion" md-sort-by="denominacion">{{
              item.denominacion
            }}</md-table-cell>
            <md-table-cell :md-label="labels.grupoArt" md-sort-by="grupoArt">{{
              item.grupoArt
            }}</md-table-cell>
            <md-table-cell :md-label="labels.producto" md-sort-by="producto">{{
              item.producto
            }}</md-table-cell>
            <md-table-cell :md-label="labels.subproducto" md-sort-by="subproducto">{{
              item.subproducto
            }}</md-table-cell>
            <md-table-cell :md-label="labels.material" md-sort-by="material">{{
              item.material
            }}</md-table-cell>
            <md-table-cell :md-label="labels.materialDes" md-sort-by="materialDes">{{
              item.materialDes
            }}</md-table-cell>
          </md-table-row>
        </md-table>
  </b-col>
        <b-col
          md="6"
          class="mx-auto empty-table pt-4"
          v-if="searched.length == 0 && users.length > 0 && !isLoading"
        >
          <h3>{{labels.notFound}}</h3>
          <p>{{labels.notFoundMessage}}: <span>{{ search }}</span></p>
        </b-col>
      </b-container>
      <b-container v-else>
        <b-col md="2" class="mx-auto">
          <div class="success-svg mb-4" :class="{ active: isEmpty }">
            <img src="../../assets/imgs/file-2.svg" alt="warning" />
          </div>
        </b-col>
        <b-col md="12" class="justify-content-around">
          <span id="message" v-if="isEmpty">{{labels.empty}}</span>
        </b-col>
      </b-container>
    </b-row>
    <b-row v-else>
      <b-col md="12" lg="12" class="p-4 mx-audo">
        <div class="text-center">
          <b-spinner></b-spinner>
        </div>
      </b-col>
    </b-row>
    <md-dialog :md-active.sync="showDialog">
      <md-dialog-title>{{labels.information}}
        <md-button class="md-icon-button md-raised md-accent" @click="deleteMaterial(dialogItem.id)"></md-button>
      </md-dialog-title>
      <md-dialog-content>
          <md-field>
            <label>{{labels.denominacion}}</label>
            <md-input v-model="dialogItem.denominacion"></md-input>
          </md-field>
          <md-field>
            <label>{{labels.grupoArt}}</label>
            <md-input v-model="dialogItem.grupoArt"></md-input>
          </md-field>
          <md-field>
            <label>{{labels.producto}}</label>
            <md-input v-model="dialogItem.producto"></md-input>
          </md-field>
          <md-field>
            <label>{{labels.subproducto}}</label>
            <md-input v-model="dialogItem.subproducto"></md-input>
          </md-field>
          <md-field>
            <label>{{labels.material}}</label>
            <md-input v-model="dialogItem.material"></md-input>
          </md-field>
          <md-field>
            <label>{{labels.materialDes}}</label>
            <md-input v-model="dialogItem.materialDes"></md-input>
          </md-field>
      </md-dialog-content>

      <md-dialog-actions>
        <md-button class="md-primary" @click="updateMaterial(dialogItem.id)">Actualizar</md-button>
        <md-button class="md-accent" @click="showDialog = false">Cerrar</md-button>
      </md-dialog-actions>
    </md-dialog>
  </div>
</template>

<script>
import Material from "@/services/Material";
const toLower = (text) => {
  console.log(text)
  return text.toString().toLowerCase();
};

const searchByLocated = (items, term) => {
  if (term) {
    return items.filter((item) =>
      toLower(item.denominacion).includes(toLower(term))
    );
  }
  return items;
};
export default {
  name: "List",

  data: () => ({
    currentSort: "denominacion",
    currentSortOrder: "asc",
    showDialog: false,
    dialogItem: {},
    materials: [],
    users: [],
    searched: [],
    search: null,
    isEmpty: false,
    isUpdating: false,
    isLoading: false,
    success: false,
    error: false,
    filename: "List.xls"
  }),
  computed:{
    labels(){
      if (this.$store.state._language == "es-ES") {
        return {
          title: "Administra los Materiales por Grupo de Articulo",
          subtitle: "Instrucciones",
          instructive: ["Puedes crear, actualizar y elemininar materiales"],
          info: "Información General",
          search: "Buscar por Denominacion",
          information: "Información del Material",
          tapLabel: "Datos",
          createdAt: "Fecha Creación",
          name: "Nombre del usuario",
          email: "Correo Electrónico",
          companyId: "Id de la Compañia",
          phonenumber: "Teléfono de contacto",
          idNumber: "Número de identificación",
          role: "Rol del Usuario",
          empty: "Aún no cuentas con usuarios",
          create: "Crear",
          active: "Activo",
          inactive: "Inactivo",
          status: "Estado",
          denominacion: "Denominación",
          grupoArt: "Grupo Art",
          producto: "Producto",
          subproducto: "Subproducto",
          material: "Material",
          materialDes: "Descripción",
        }
      }else {
        return {
          title: "Invoice Visualization Platform",
          subtitle: "Instructions",
          instructive: ["Welcome to the platform for the visualization and creation of users."],
          info: "General Information",
          search: "Search by User Name",
          information: "Información del Usuario",
          tapLabel: "Datos",
          createdAt: "Created Date",
          name: "User Name",
          email: "Email",
          companyId: "Company Id",
          phonenumber: "Contact Number",
          idNumber: "Identification Id",
          role: "Role",
          empty: "You don't have users yet",
          create: "Create",
          active: "Activo",
          inactive: "Inactive",
          status: "Status",
          denominacion: "Denominación",
          grupoArt: "Grupo Art",
          producto: "Producto",
          subproducto: "Subproducto",
          material: "Material",
          materialDes: "Descripción",
        }
      }
    }
  },
  methods: {
    goToCreateMaterial(){
      this.$router.push({path: 'materials/create'})
    },
    showInfo(id) {
      const currentIdx = this.materials.findIndex((obj) => obj.id == id);
      this.dialogItem = this.materials[currentIdx];
      this.showDialog = true
    },
    deleteMaterial(id) {
      this.showDialog = false
      this.isLoading = true;
      Material.deleteMaterial(id).then(() => {
        this.isLoading = false;
      });
      this.materials = this.materials.filter( material => material.id != id );
      this.searched = this.materials
    },
    updateMaterial(id){
      this.isLoading = true;
      Material.updateMaterial(id).then(() => {
        this.isLoading = false;
      });
      this.searched = this.materials
    },
    customSort(value) {
      // console.log(value);
      return value.sort((a, b) => {
        const sortBy = this.currentSort;

        if (this.currentSortOrder === "desc") {
          return a[sortBy].toString().localeCompare(b[sortBy].toString());
        }

        return b[sortBy].toString().localeCompare(a[sortBy].toString());
      });
    },
    searchOnTable() {
      this.searched = searchByLocated(this.materials, this.search);
    },
  },
  mounted() {
    this.isLoading = true;
    Material.getAllMaterials()
      .then((result) => {
        // console.log(result.data)
        this.materials = result.data.tipoMaterial;
        this.searched = this.materials;
        if (this.materials.length == 0) {
          this.isEmpty = true;
        }
      })
      .catch(() => {
        // console.log(error);
        this.error = true;
      })
      .finally(() => {
        this.isLoading = false;
      });
  },
};
</script>

<style src="../main.css">
</style>
